import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];

  connect() {
    this.scrollTimeout = null;
    this.element.addEventListener("scroll", this.handleScroll.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    this.element.classList.add("scrolling");

    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    this.scrollTimeout = setTimeout(() => {
      this.element.classList.remove("scrolling");
    }, 500);
  }
}
